import { Injectable } from '@angular/core';

export enum AdminUrlType{
  Dashboard,
  ProductList,
  ProductAdd,
  ProductEdit,
  Customers
}

export enum ProductsUrlType{
  List,
  Detail,
  CardEdit,
  DetailEdit
}

@Injectable()
export class GeneralHelperService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/services/utility/general-helper.service.ts